module.exports = __webpack_public_path__ + "static/media/6_2.07eb7c52.png";